import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "@themes/pollinator/ui/Loader";
import { useFetchStaticPage } from "@core/features/support";
import { StaticPage } from "./StaticPage";

export function StaticPageContainer() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const { data, isLoading, error, isError } = useFetchStaticPage({ slug });

  useEffect(() => {
    if (isError && error) {
      navigate("/not-found");
    }
  }, [isError, error, navigate]);

  if (isLoading) return <Loader isFullPage />;

  if (isError) return null;

  return <StaticPage article={data?.article} />;
}

export default StaticPageContainer;

